module.exports = __webpack_public_path__ + "teqbahn-assets/media/13.c8f8c4d5.png";